<div class="layout-ParentDiv innerDiv">
	<div class="layout-dashboard" [ngClass]="hide ? 'responsiveHide-column' : 'responsiveShow-column'">
		<div class="mainDivHeader">
			<div class="leftdiv">
				<h4>Sub Category Management <span class="badge">{{totalRecords }}</span></h4>
			</div>
			<div class="rightDiv">
				<button class="exportBTn" (click)="exportExcel()"> <span><img
							src="../../../assets/images/backend-image/header/exportIcon.svg" alt=""></span>
					Export</button>
				<button class="addBTn" (click)="addNewCategory()"> <span><img
							src="../../../assets/images/backend-image/header/plus.svg" alt=""></span> Add
					Category</button>
			</div>
		</div>
		<div class="mainDivBody">
			<div class="date-filterDiv">
				<ul class="filtersList">
					<li>
						<p-dropdown inputId="searchfield" [options]="searchBy" [(ngModel)]="searchby"
							placeholder="Select Field" optionLabel="label"></p-dropdown>
					</li>
					<li>
						<p-calendar placeholder="From: dd / mm / yy" appendTo="body" monthNavigator="true"
							yearNavigator="true" yearRange="2022:2050" [(ngModel)]="startDate" class="p-calendar w-100"
							inputId="calendar" dateFormat="dd/mm/yy" [showIcon]="true"></p-calendar>
					</li>
					<li>
						<p-calendar placeholder="To: dd / mm / yy" appendTo="body" monthNavigator="true"
							yearNavigator="true" yearRange="2022:2050" [(ngModel)]="endDate" class="p-calendar"
							inputId="calendar" dateFormat="dd/mm/yy" [showIcon]="true"></p-calendar>
					</li>
					<li>
						<button (click)="loadCategory($event)" class="searchFilterBtn">
							<img src="../../../assets/images/backend-image/common-images/search.svg" alt="">
						</button>
					</li>
					<li>
						<button class="clearFilterBtn" (click)="clear()">
							<img src="../../../assets/images/backend-image/common-images/delete.svg" alt="">
							<span>Clear All</span>
						</button>

					</li>
				</ul>

			</div>
			<div class="maintableDiv">
				<div class="tableParanet">
						<p-table #dt [value]="categoryList" [paginator]="true" [rows]="10" [lazy]="true"
						(onLazyLoad)="loadCategory($event)" [totalRecords]="totalRecords" [loading]="loading"
						[rowsPerPageOptions]="paginationOption" paginatorPosition="bottom"
						styleClass="p-datatable-gridlines p-datatable-striped">
						<!-- <ng-template pTemplate="caption">
					<div class="p-d-flex p-flex-column p-flex-md-row table-header">						
						<span class="p-input-icon-right">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
						    placeholder="Global Search"/>
                        </span>                        
					</div>
				</ng-template> -->
						<ng-template pTemplate="header" let-columns>

							<tr>
								<th pSortableColumn="name" class="nameTd">
									<div class="p-d-flex p-jc-between p-ai-center">
										Name
										<p-sortIcon field="name"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="parent_category" class="parent_categoryTd">
									<div class="p-d-flex p-jc-between p-ai-center">
										Parent Category
										<p-sortIcon field="parent_category"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="created_at" class="created_atTD">
									<div class="p-d-flex p-jc-between p-ai-center">
										<div class="table-lable">
											Date <span class="responsive-tag">of Creation</span>
										</div>
										<p-sortIcon field="created_at"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="created_by" class="created_byTd">
									<div class="p-d-flex p-jc-between p-ai-center">
										<div class="table-lable">
											Created <span class="responsive-tag">By</span>
										</div>

										<p-sortIcon field="created_by"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="updated_at" class="updated_atTd">
									<div class="p-d-flex p-jc-between p-ai-center">
										<div class="table-lable">
											Last Modified <span class="responsive-tag">On</span>
										</div>


										<p-sortIcon field="updated_at"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="updated_by" class="updated_byTd">
									<div class="p-d-flex p-jc-between p-ai-center">
										<div class="table-lable">
											Modified <span class="responsive-tag">By</span>
										</div>
										<p-sortIcon field="updated_by"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="status" class="statusTD">
									<div class="p-d-flex p-jc-between p-ai-center">
										Status
										<p-sortIcon field="status"></p-sortIcon>
									</div>
								</th>
								<th class="actionTD p-frozen-column">  
									 
										Action 
								</th>
							</tr>
							<tr>
								<th [ngSwitch]="name" class="nameTd">
									<input pInputText type="text"
										(keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'name', 'contains')"
										style="width: 90px;"
										[value]="dt.filters['name'] ? dt.filters['name'].value : ''" />
								</th>
								<th [ngSwitch]="parent_category" class="parent_categoryTd">
									<input pInputText type="text"
										(keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'parent_category', 'contains')"
										style="width: 90px;"
										[value]="dt.filters['parent_category'] ? dt.filters['parent_category'].value : ''" />
								</th>
								<th [ngSwitch]="created_at" class="created_atTD">
									<p-calendar appendTo="body" #pCalendarId class="p-column-filter" inputId="calendar"
										dateFormat="dd/mm/yy"
										(onSelect)="setDownloadFlag(); dt.filter($event,'created_at', 'dateIs')"
										monthNavigator="true" yearNavigator="true" yearRange="2022:2050"
										[showIcon]="true" [(ngModel)]="calvalue"></p-calendar>
								</th>
								<th [ngSwitch]="createdby" class="createdbyTd">
									<input pInputText type="text"
										(keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'createdby', 'contains')"
										style="width: 90px;"
										[value]="dt.filters['createdby'] ? dt.filters['createdby'].value : ''" />
								</th>
								<th [ngSwitch]="updated_at" class="updated_atTd">
									<p-calendar appendTo="body" #pCalendarId class="p-column-filter" inputId="calendar"
										dateFormat="dd/mm/yy"
										(onSelect)="setDownloadFlag(); dt.filter($event,'updated_at', 'dateIs')"
										monthNavigator="true" yearNavigator="true" yearRange="2022:2050"
										[showIcon]="true" [(ngModel)]="ucalvalue"></p-calendar>
								</th>
								<th [ngSwitch]="updatedby" class="updatedbyTd">
									<input pInputText type="text"
										(keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'updatedby', 'contains')"
										style="width: 90px;"
										[value]="dt.filters['updatedby'] ? dt.filters['updatedby'].value : ''" />
								</th>
								<th [ngSwitch]="status" class="statusTD">
									<p-dropdown #pDropDownId [options]="statuses" [style]="{'width':'100%'}"
										(onChange)="setDownloadFlag(); dt.filter($event.value, 'status', 'equals')"
										styleClass="p-column-filter" placeholder="Select Status" [showClear]="true">
										<ng-template let-option pTemplate="item">
											<span
												[class]="'customer-badge status-' + option.value">{{option.label}}</span>
										</ng-template>
									</p-dropdown>
								</th>
								<th class="actionTD p-frozen-column">
								</th>
							</tr>
						</ng-template>
						<ng-template pTemplate="body" let-category>
							<tr class="p-selectable-row">
								<td class="nameTd">
									{{category.name}}
								</td>
								<td class="parent_categoryTd">
									{{category.parent_category}}
								</td>
								<td class="created_atTD">
									{{category.created_at | date: 'MM/dd/yyyy'}}
								</td>
								<td class="created_byTd">
									{{category.createdBy}}
								</td>
								<td class="updated_atTd">
									{{category.updated_at | date: 'MM/dd/yyyy'}}
								</td>
								<td class="updated_byTd">
									{{category.updatedBy}}
								</td>
								<td class="statusTD">
										<div class="swichTable">
										<p-inputSwitch [(ngModel)]="category.status" (onChange)="changeStatus(category)"
											class="d-flex"></p-inputSwitch>
										<div class="label activeText" *ngIf="category.status">
											Active
										</div>
										<div class="label InActiveText" *ngIf="!category.status">
											Inactive
										</div>
									</div>

									<!-- <div class="checkbox p-d-flex align-items-center">
										<span *ngIf="category.status">
											<p-tag styleClass="mr-2" severity="success" value="Active"></p-tag>
										</span>
										<span *ngIf="!category.status">
											<p-tag severity="danger" styleClass="mr-2" value="In-Active"></p-tag>
										</span>
										<p-inputSwitch [(ngModel)]="category.status" (onChange)="changeStatus(category)"
											class="d-flex"></p-inputSwitch>
									</div> -->

								</td>
								<td class="actionTD p-frozen-column">
										<ul class="actionList">
										
										<li *ngIf="!category.default_data">
											<button (click)="editCategory(category.id)"  class="editBtn"><img
													src="../../../assets/images/backend-image/common-images/editeBtn.svg"></button>
										</li>
										<li>
											<button (click)="deleteCategory(category)" class="deleteBtn"><img
													src="../../../assets/images/backend-image/common-images/deleteBtn.svg"></button>
										</li>
										<li>
											<button (click)="viewCategory(category.id)" class="viewBtn"><img
													src="../../../assets/images/backend-image/common-images/view.svg"></button>
										</li>
									</ul> 

									<!-- <button pButton pRipple icon="pi pi-eye"
										class="p-button-rounded p-button-info p-mr-2"
										(click)="viewCategory(category.id)"></button>
									<span *ngIf="!category.default_data">
										<button pButton pRipple icon="pi pi-pencil"
											class="p-button-rounded p-button-success p-mr-2"
											(click)="editCategory(category.id)"></button>
										<button pButton pRipple icon="pi pi-trash"
											class="p-button-rounded p-button-danger"
											(click)="deleteCategory(category)"></button>
									</span> -->
								</td>
							</tr>
						</ng-template>
						<ng-template pTemplate="emptymessage">
							<tr>
								<td colspan="7">Sub Category not found.</td>
							</tr>
						</ng-template>
						<!-- <ng-template pTemplate="summary">
							<div class="p-d-flex p-ai-center p-jc-between">
								In total there are {{totalRecords }} Sub Category.
							</div>
						</ng-template> -->
					</p-table>
				</div>
			</div>
		</div> 
	</div>
</div>

<p-confirmDialog [style]="{width: '400px'}" id="confirmDialog"></p-confirmDialog>
